import { ReactElement } from 'react';

import { Text } from '@components/Text';
import i18n from '@translations';

export const TimeoutAdornment = (translationKey: string): ReactElement => (
  <Text $level={6} $customizeColor className="text-us flex items-center justify-end text-center w-full text-slate-500">
    {i18n.t(translationKey)}
  </Text>
);
